
class HXFormFieldPassword extends HXFormField {

    constructor(inputName,formName) {
        super(inputName,formName);
    }

    /**
     * @returns {boolean}
     */
    validateInput(alertResult=true) {
        super._validateFieldInit();

        if (this.fieldExists()===true && this.getEditable() === true) {
            var value = ''+this.getValue();

            if (!this.getOptional() && value === '') {
                this.validationMsg = hx.replace(this.formVars.dictOptionalMsg, "#name#", this.getLabel());
                this.validationPassed = false;
            }
            if (alertResult===true) super._validateFieldAlert();

        }
        return this.validationPassed;
    }

    /**
     * @param {boolean} optional
     */
    setOptional(optional) {
        super.setOptional(optional,'text');
    }

    /**
     * Events einhaengen
     */
    displayInit() {

    }

}




